import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import withOutsideClickControl from 'src/common/decorators/withOutsideClickControl';
import { selectIsDiscord } from 'src/common/selectors/app';
import { selectFollowOptions } from 'src/common/selectors/player';
import { FavoriteOption } from '../../FavoriteOption';
import { FavoriteIconControl } from './FavoriteIconControl';
import FavoriteOptionSelector from './FavoriteOptionSelector';
import css from './favorite-control-with-options.module.scss';

export function FavoriteControlWithOptions({
  showIconLabel,
  fill,
  iconClassName,
  unFavoritedClassName,

  // From withOutsideClickControl HOC
  handleOnClick,
  isOpen,
  containerRef,
}) {
  const followOptions = useSelector(selectFollowOptions);
  const isDiscord = useSelector(selectIsDiscord);

  return (
    <div
      className={css.container}
      data-testid="favoriteControlWithOptionsContainer"
      ref={containerRef}
    >
      <FavoriteOptionSelector
        isOpen={isOpen}
        onClose={() => handleOnClick(false)}
        popoverClassName={css.popover}
        dialogBodyClassName={css.dialogBody}
        dialogContentClassName={css.dialogContent}
        closeIconAttributes={{
          className: css.closeIcon,
          hasDarkTheme: isDiscord,
        }}
      >
        <div className={css.content}>
          <div data-testid="follow-options-header" className={css.header}>
            Options
          </div>
          {followOptions?.map((followOption) => {
            return (
              <FavoriteOption
                followActionOrOption={followOption}
                key={followOption.guideId}
                iconClassName={iconClassName || css.favoriteIcon}
                unFavoritedClassName={unFavoritedClassName}
              />
            );
          })}
        </div>
      </FavoriteOptionSelector>

      {/* This UI only controls the option to open/close the selector above, per isOptionsController */}
      <FavoriteIconControl
        showIconLabel={showIconLabel}
        fill={fill}
        isOptionsController
        handleOptionClick={handleOnClick}
        iconClassName={iconClassName}
        unFavoritedClassName={unFavoritedClassName}
      />
    </div>
  );
}

FavoriteControlWithOptions.propTypes = {
  showIconLabel: PropTypes.bool,
  fill: PropTypes.string,

  // From withOutsideClickControl HOC
  handleOnClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  containerRef: PropTypes.object.isRequired,
};

export default withOutsideClickControl(FavoriteControlWithOptions);
